<app-menu class="menuApp"></app-menu>
<div class="main">
  <div style="width: 90%; margin: auto; height: 100%">

    <div class="row">
      <div class="col-2" style="margin-top: 2vh">
        <button id="buttonProfiles" (click)="listaFades()" class="buttonNewRegla">
          <span class="material-icons-outlined customIcon textXM">settings</span>
          <h4 class="textS" style="margin: auto">{{this.localiser.get("fade.buttonProfiles")}}</h4>
        </button>
      </div>
      <div class="col-2" style="margin-top: 2vh">
        <button (click)="listaGrupos()" class="buttonNewRegla">
          <span class="material-icons-outlined customIcon textXM">settings</span>
          <h4 class="textS" style="margin: auto">{{this.localiser.get("fade.buttonGroups")}}</h4>
        </button>
      </div>
      <!--
      <div class="col-2" style="margin-top: 2vh">
        <button (click)="sendAllFades()" class="buttonNewRegla textS">Enviar Fades</button>
      </div>
      <div class="col-2" style="margin-top: 2vh">
        <button (click)="sendAllRelations()" class="buttonNewRegla textS">Enviar Relaciones</button>
      </div>
      -->
    </div>

    <div class="row deviceHeader">
      <h1 class="marginAuto textXXM">{{this.localiser.get("fade.title")}}</h1>
    </div>

    <div class="row" style="height: 70%">
      <div class="col-3" style="border-right: 2px solid #18264f">
        <div class="row">
          <mat-form-field id="fadeSelector" appearance="fill" style="width: 90%; margin: auto">
            <mat-label class="textS">{{this.localiser.get("fade.buttonProfiles")}}</mat-label>
            <mat-select id="fadeSelector" (selectionChange)="selectFade($event)" [(ngModel)]="fadeSelect" [placeholder]="this.localiser.get('fade.buttonProfiles')"
                        class="selectFilter textS">
              <mat-option class="textS" [value]="'-1'"><b>None</b></mat-option>
              <mat-option class="textS" *ngFor="let fade of fades" [value]="fade">{{fade.nombre}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div *ngIf="fadeSelect != undefined" class="row" style="width: 90%; margin: auto">
          <h3 id="fadeInLabel" class="textS+" style="margin-top: 4%">{{this.localiser.get("fade.profiles.fadeIn")}}: {{selectedFadeInTimeNominalValue}}{{this.localiser.get("fade.profiles.seconds")}}</h3>
          <!--<h3 class="textS+" style="margin-top: 4%">{{this.localiser.get("fade.profiles.fadeIn")}}: {{fadeSelect.fade_in}}{{this.localiser.get("fade.profiles.seconds")}}</h3>-->
          <h3 class="textS+" style="margin-top: 4%">{{this.localiser.get("fade.profiles.maxT")}}: {{fadeSelect.max_t / 60}}{{this.localiser.get("fade.profiles.minutes")}}</h3>
          <h3 id="fadeOutLabel" class="textS+" style="margin-top: 4%">{{this.localiser.get("fade.profiles.fadeOut")}}: {{selectedFadeOutTimeNominalValue}}{{this.localiser.get("fade.profiles.seconds")}}</h3>
          <!--<h3 class="textS+" style="margin-top: 4%">{{this.localiser.get("fade.profiles.fadeOut")}}: {{fadeSelect.fade_out}}{{this.localiser.get("fade.profiles.seconds")}}</h3>-->
          <h3 class="textS+" style="margin-top: 4%">{{this.localiser.get("fade.profiles.minT")}}: {{fadeSelect.min_t / 60}}{{this.localiser.get("fade.profiles.minutes")}}</h3>
          <h3 class="textS+" style="margin-top: 4%">{{this.localiser.get("fade.profiles.maxWork")}}: {{fadeSelect.work_max}}</h3>
          <h3 class="textS+" style="margin-top: 4%">{{this.localiser.get("fade.profiles.minWork")}}: {{fadeSelect.work_min}}</h3>
        </div>
      </div>
      <div class="col-9" style="height: 100%">

        <div class="row">
          <div class="col" style="text-align: left; padding-left: 5%; height: fit-content">
            <div class="row" style="height: 50%">
              <label class="textS labelSearch">{{this.localiser.get('devices.searcher')}}</label>
            </div>
            <div class="row" style="height: 50%">
            <span class="material-icons-outlined textXM" style="color: white; width: 10%">
                search
            </span>
              <input [(ngModel)]="searcherLuminarias" type="text" class="textS searcherInput" style="width: 65%"
                     (input)="loadLuminarias()" maxlength="50">
            </div>
          </div>
          <div class="col">
            <mat-form-field appearance="fill">
              <mat-label class="textS">{{this.localiser.get("devices.floorplan")}}</mat-label>
              <mat-select (selectionChange)="selectPlano($event)" [(ngModel)]="planoSelected" [placeholder]="this.localiser.get('devices.floorplan')"
                          class="selectFilter textS">
                <mat-option class="textS" [value]="'all'"><b>{{this.localiser.get("fade.groups.all")}}</b></mat-option>
                <mat-option class="textS" *ngFor="let plano of planos" [value]="plano">{{plano.nombre}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col">
            <mat-form-field appearance="fill">
              <mat-label class="textS">{{this.localiser.get("fade.group")}}</mat-label>
              <mat-select (selectionChange)="selectGrupo($event)" [(ngModel)]="grupoSelected" [placeholder]="this.localiser.get('fade.group')"
                          class="selectFilter textS">
                <mat-option class="textS" [value]="'all'"><b>{{this.localiser.get("fade.groups.all")}}</b></mat-option>
                <mat-option class="textS" *ngFor="let grupo of grupos" [value]="grupo">{{grupo.nombre}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="row" style="margin-top: 2%; height: 60%; overflow: auto">
          <div class="col">
            <div *ngFor="let luminaria of luminarias; index as i;">
              <div *ngIf="i % 2 == 0" class="luminariaCard" (click)="changeFadeOfLumaria(luminaria)"
                   [ngClass]="{'backNoProfile': fadeSelect != undefined && luminaria.idFade == '-1',
                               'backIsProfile': fadeSelect != undefined && luminaria.idFade == fadeSelect.id,
                               'backIsNotProfile': fadeSelect != undefined && luminaria.idFade != fadeSelect.id && luminaria.idFade != '-1'}">
                <h1 class="textS+" style="margin: 5% auto auto auto; text-decoration: underline">{{luminarias[i].nombre}}</h1>
                <h1 class="textS" style="margin: 1% auto auto auto">{{luminarias[i].idDispositivo}}</h1>
                <h1 class="textS" style="margin: 1% auto 5% auto">{{this.localiser.get("fade.profile")}}: {{fadeNombreById(luminarias[i].idFade)}}</h1>
              </div>
            </div>
          </div>
          <div class="col">
            <div *ngFor="let luminaria of luminarias; index as i;">
              <div *ngIf="i % 2 == 1" class="luminariaCard" (click)="changeFadeOfLumaria(luminaria)"
                   [ngClass]="{'backNoProfile': luminaria.idFade == '-1',
                               'backIsProfile': fadeSelect != undefined && luminaria.idFade == fadeSelect.id,
                               'backIsNotProfile': fadeSelect != undefined && luminaria.idFade != fadeSelect.id && luminaria.idFade != '-1'}">
                <h1 class="textS+" style="margin: 5% auto auto auto; text-decoration: underline">{{luminarias[i].nombre}}</h1>
                <h1 class="textS" style="margin: 1% auto auto auto">{{luminarias[i].idDispositivo}}</h1>
                <h1 class="textS" style="margin: 1% auto 5% auto">{{this.localiser.get("fade.profile")}}: {{fadeNombreById(luminarias[i].idFade)}}</h1>
              </div>
            </div>
          </div>
        </div>

        <div class="row" style="margin-top: 2%; height: 10%; width: 100%">
          <div class="col" style="display: flex">
            <div style="height: 50%; width: 20%; background-color: white; border: 1px solid black; margin: auto 1%">

            </div>
            <h3 class="textS" style="margin: auto 1%">{{this.localiser.get("fade.noProfile")}}</h3>
          </div>
          <div class="col" style="display: flex">
            <div style="height: 50%; width: 20%; background-color: #18264f; border: 1px solid black; margin: auto 1%">

            </div>
            <h3 class="textS" style="margin: auto 1%">{{this.localiser.get("fade.profileAssigned")}}</h3>
          </div>
          <div class="col" style="display: flex">
            <div style="height: 50%; width: 20%; background-color: #F2A356; border: 1px solid black; margin: auto 1%">

            </div>
            <h3 class="textS" style="margin: auto 1%">{{this.localiser.get("fade.notProfileAssigned")}}</h3>
          </div>
        </div>

      </div>
    </div>

  </div>
</div>
